export default "__VITE_ASSET__BccqoEAZ__"